exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  font-family: \"Roboto\", sans-serif;\n}\n\nhtml,\nbody {\n  height: 100%;\n}\n\n#root {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n}\n\n.Root__container___7mgx2 {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n@media (min-width: 800px) {\n  .Root__container___7mgx2 {\n    flex-direction: row;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "Root__container___7mgx2"
};